export default __webpack_public_path__ + "assets/webgl/scene-22.9ca6d495.glb";